import React from 'react';
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import useFetchWithMsal from '../services/useFetchWithMsal';
import { apiRoutes } from '../services/apiRoutes';
import dateFormats from "../Data/dateFormats.json";
import { DateFormater } from "../services/DateFormater"
import { CustomerPortalLoginHistoryGrid } from '../components/Grid/CustomerPortalLoginHistoryGrid';
import { Layout } from '../components/MasterPage/Layout';
import CustomerPortalLoginHistoryGridColumns from "../Data/CustomerPortalLoginHistoryGridColumns.json";
import { ColumnManager } from "../services/columnManager";

export function CustomerPortalLoginHistory(props) {
	const { columnResize, columnReorder, onColumnsSubmit, defaultSettings } = ColumnManager(CustomerPortalLoginHistoryGridColumns, "CustomerPortalLoginHistoryGridSettings");
	const [stateColumns, setStateColumns] = React.useState(defaultSettings);
	let maxDate = new Date();
	if (maxDate.getUTCDate() !== maxDate.getDate())
		maxDate = new Date(maxDate.setDate(maxDate.getUTCDate()));
	const [dateFormatFilter, setdateFormatFilter] = React.useState("dd/MM/yyyy hh:mm:ss a");

	const { adjustForTimezone } = DateFormater();
	let navigate = useNavigate();

	const [downloadGrid, setdownloadGrid] = React.useState(false);
	const [showColumnSelect, setshowColumnSelect] = React.useState(false); 
	const [buttonsConfig, setbuttonsConfig] = React.useState([]);

	const [CustomerPortalLoginHistoryData, setCustomerPortalLoginHistoryData] = React.useState([]);
	const [dataStateBackend, setDataStateBackend] = React.useState({ skip: 0, take: 25, sort: "", filter: "", total: 0 });
	const [pending, setPending] = React.useState(false);

	const [startDateState, setstartDate] = React.useState(new Date(new Date().getTime() - 604800000));
	const [endDateState, setendDate] = React.useState(new Date());
	const [exportData, setexportData] = React.useState([]);
	const [getExportData, setgetExportData] = React.useState(false);

	const [portalUsers, setportalUsers] = React.useState([]);
	const [portals, setportals] = React.useState([]);

	const _exporter = React.createRef();
	const exportFunction = () => {
        if (_exporter.current) {
            _exporter.current.save();
        }
	};

	React.useEffect(() => {
		if (downloadGrid) {
			exportFunction();
			setdownloadGrid(false);
		}
	}, [downloadGrid]);

	React.useEffect(() => {
		if (getExportData) {
			getExport();
			setgetExportData(false);
		}
	}, [getExportData]);

	const changestartDate = (event) => {
		setstartDate(new Date(event.value));
		let newDataState = { skip: 0, take: 25, sort: "", filter: "", total: 0 };
		setDataStateBackend(newDataState);
		getData(newDataState, event.value.toJSON());
	};
	const changeendDate = (event) => {
		setendDate(new Date(event.value));
		let newDataState = { skip: 0, take: 25, sort: "", filter: "", total: 0 };
		setDataStateBackend(newDataState);
		getData(newDataState, null, event.value.toJSON());
	};

	const { execute } = useFetchWithMsal({
		scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
	});

	const onPageChange = async (e) => {
		let dsBackend = dataStateBackend;
		dsBackend = { ...dsBackend, ...e.page };

		getData(dsBackend);
	};

	const onFilterChange = async (e) => {
		let dsBackend = dataStateBackend;
		dsBackend = { ...dsBackend, filter: e.filter };

		setDataStateBackend(dsBackend);
		getData(dsBackend);
	};

	const onSortChange = async (e) => {
		let dsBackend = dataStateBackend;
		dsBackend = { ...dsBackend, sort: e.sort };

		getData(dsBackend);
	};

	const getState = async () => {
		return dataStateBackend;
	};
	const saveState = async (newState) => {
		setDataStateBackend(newState);
	};

	const onDataStateChange = async (e) => {
		'use server';

		await saveState({
			...await getState(),
			sort: e.dataState.sort,
			filter: e.dataState.filter,
			group: e.dataState.group,
			skip: e.dataState.skip,
			take: e.dataState.take
		});
	};

	React.useEffect(() => {
		localStorage.removeItem("languages");
		if (props.localizations.IncludeActive != null) {
			setbuttonsConfig([
				{
					type: 'secondary',
					icon: 'icon-ui-general-libraries',
					tooltip: props.localizations.Columns,
					position: "top",
					onClick: () => { setshowColumnSelect(true); }
				},
				{
					type: 'secondary',
					icon: 'icon-ui-general-download',
					tooltip: props.localizations.Download,
					position: "top",
					onClick: () => { setgetExportData(true); }
				}
			]);
			if (props.customer.DateFormatId != null) {
				let format = dateFormats.find((x) => x.value === props.customer.DateFormatId);
				if (format != null) {
					setdateFormatFilter(format.text + " hh:mm:ss a");
				}
			}
			if (props.currentTenent.CustomerId != null && !props.currentTenent.IsEditCustomerPortalUser)
				navigate("/NoPermissions");
		}
	}, [props.localizations]);

	React.useEffect(() => {
		if (execute != null) {
			getData(dataStateBackend);
			getCheckboxOptions();
		}
	}, [execute]);

	const getData = (dsBackend, startDate, endDate) => {
		if (dsBackend == null || dsBackend.skip == null)
			dsBackend = dataStateBackend;

		if (startDate == null)
			startDate = startDateState.toJSON();
		if (endDate == null)
			endDate = endDateState.toJSON();

		setPending(true);
		let sort = dsBackend.sort == null || dsBackend.sort == "" ? "loginDate,desc" : dsBackend.sort[0].field + "," + dsBackend.sort[0].dir;

		let filter = "";
		if (dsBackend.filter != null && dsBackend.filter.filters != null && dsBackend.filter.filters.length > 0)
			dsBackend.filter.filters.forEach(x => {
				x.filters.forEach(y => {
					filter += y.field + "," + y.operator + "," + (y.value.getTime != null ? y.value.toJSON() : y.value) + "," + x.logic + "|";
				});
			});

		execute("GET", `${apiRoutes.publicSites.CustomerPortalLoginHistory(startDate, endDate, dsBackend.skip, dsBackend.take, sort, filter)}`)
			.then(json => {
				if (json != null) {
					json.documents.forEach((doc) => {
						doc.loginDate = adjustForTimezone(doc.loginDate.substring(0, doc.loginDate.indexOf(".")), props.customer.TimezoneId);
					});

					setCustomerPortalLoginHistoryData(json.documents);
					setDataStateBackend({ skip: json.skip, take: json.take, total: json.total, sort: dsBackend.sort, filter: dsBackend.filter })
					setPending(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	const getCheckboxOptions = () => {
		let userTypeId = 4;
		execute("GET", `${apiRoutes.users.get}?localeId=${props.languageValue.localeId}&userTypeId=${userTypeId}`)
			.then(json => {
				if (json != null) {
					let users = json.map(x => ({ value: x.userName, title: x.userName, username: x.userName }));
					setportalUsers(users);
				}
			})
			.catch((err) => {
				console.log(err);
			});

		execute("GET", apiRoutes.publicSites.get)
			.then(json => {
				if (json && json.length !== 0) {
					let sites = json.map(x => ({ value: x.name, title: x.name, publicSiteName: x.name }));
					setportals(sites);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	const getExport = (dsBackend, startDate, endDate) => {
		if (dsBackend == null || dsBackend.skip == null)
			dsBackend = dataStateBackend;

		if (startDate == null)
			startDate = startDateState.toJSON();
		if (endDate == null)
			endDate = endDateState.toJSON();

		setPending(true);
		let sort = dsBackend.sort == null || dsBackend.sort == "" ? "loginDate,desc" : dsBackend.sort[0].field + "," + dsBackend.sort[0].dir;

		let filter = "";
		if (dsBackend.filter != null && dsBackend.filter.filters != null && dsBackend.filter.filters.length > 0)
			dsBackend.filter.filters.forEach(x => {
				x.filters.forEach(y => {
					filter += y.field + "," + y.operator + "," + (y.value.getTime != null ? y.value.toJSON() : y.value) + "," + x.logic + "|";
				});
			});

		execute("GET", `${apiRoutes.publicSites.CustomerPortalLoginHistoryExport(startDate, endDate, sort, filter)}`)
			.then(json => {
				if (json != null) {
					json.documents.forEach((doc) => {
						doc.loginDate = adjustForTimezone(doc.loginDate.substring(0, doc.loginDate.indexOf(".")), props.customer.TimezoneId);
					});

					setexportData(json.documents);
					setPending(false);
					setdownloadGrid(true);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	return (
		<Layout versionNumber={props.versionNumber} buttonsConfig={buttonsConfig} currentTenent={props.currentTenent} localizations={props.localizations} changeLanguage={props.changeLanguage} languageValue={props.languageValue} >
			<div>
				<label className="dsStartDateLabel">{props.localizations.Start}</label><label className="dsEndDateLabel">{props.localizations.End}</label>
			</div>
			<div className="dsCriteriaDiv" >
				<DatePicker
					className="dsStartDate"
					width={225}
					max={endDateState}
					format={dateFormatFilter}
					value={startDateState}
					onChange={changestartDate}
					navigation={false}
				/>
				<DatePicker
					className="dsEndDate"
					width={225}
					min={startDateState}
					max={maxDate}
					format={dateFormatFilter}
					value={endDateState}
					onChange={changeendDate}
					navigation={false}
				/>
			</div>
			<div>
				<CustomerPortalLoginHistoryGrid portalUsers={portalUsers} portals={portals} customer={props.customer} dateFormatId={props.customer.DateFormatId} localizations={props.localizations} onPageChange={onPageChange} onFilterChange={onFilterChange} onSortChange={onSortChange}
					pending={pending} CustomerPortalLoginHistoryData={CustomerPortalLoginHistoryData} onDataStateChange={onDataStateChange} dataStateBackend={dataStateBackend} stateColumns={stateColumns} setStateColumns={setStateColumns}
					showColumnSelect={showColumnSelect} downloadGrid={downloadGrid} setdownloadGrid={setdownloadGrid} setshowColumnSelect={setshowColumnSelect} columnResize={columnResize} columnReorder={columnReorder} onColumnsSubmit={onColumnsSubmit} />

				<ExcelExport data={exportData} fileName="UserLogins.xlsx" ref={_exporter}>
					{stateColumns.map(
						(column, idx) =>
							column.show && !column.ExcludeFromExport && (
								<ExcelExportColumn
									key={idx}
									field={column.field}
									title={props.localizations[column.title]}
								/>
							)
					)}
				</ExcelExport>
			</div>
		</Layout>
	);
}
